//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// РФ:
const LON_MIN = 19.0
const LON_MAX = 180.0
const LAT_MIN = 41.0
const LAT_MAX = 82.0

export default {
  props: {
    value: {
      type: Array,
      default () {
        return [[null, null]]
      }
    }
  },
  data: function () {
    const value = [this.value[0].slice()]
    value[0][0] = this.coordinateToString(value[0][0])
    value[0][1] = this.coordinateToString(value[0][1])
    return {
      valueLocal: value
    }
  },
  computed: {
    coordinateOrderLonLat: function () {
      return this.$store.getters.getUserSetting('ui.common.coordinateOrder', 'lonlat') === 'lonlat'
    },
    validationLon: function () {
      if (this.valueLocal) {
        return this.validationLocation(this.valueLocal[0][0], LON_MIN, LON_MAX)
      }
      return null
    },
    validationLat: function () {
      if (this.valueLocal) {
        return this.validationLocation(this.valueLocal[0][1], LAT_MIN, LAT_MAX)
      }
      return null
    },
    valid: function () {
      if (this.valueLocal && this.valueLocal[0][0] && this.valueLocal[0][1]) {
        return !!this.validationLon && !!this.validationLat
      }
      return false
    }
  },
  watch: {
    valid: {
      handler: function (valid) {
        this.$emit('update:valid', valid)
      },
      immediate: true
    }
  },
  mounted: function () {
    this.$refs.lon.validate()
    this.$refs.lat.validate()
  },
  methods: {
    coordinateToString: function (value) {
      return value ? value.toFixed(6) : null
    },
    coordinateToNumber: function (value) {
      return value && value.length ? Number(value) : null
    },
    validationLocation: function (value, min, max) {
      return this.ruleLocation(value, min, max) === true
    },
    ruleLocation: function (value, min, max) {
      if (value) {
        const numValue = this.coordinateToNumber(value)
        if (isNaN(numValue)) {
          if (value.includes(',')) {
            return 'Введите значение через точку'
          }
          return 'Значение должно быть числом'
        }
        if (numValue < min || numValue > max) {
          return 'За пределами допустимого региона'
        }
        const dotIndex = value.indexOf('.')
        if (dotIndex === -1 || value.length - dotIndex - 1 !== 6) {
          return 'Необходимо заполнить 6 знаков после точки'
        }
      }
      return true
    },
    ruleLat: function (value) {
      return this.ruleLocation(value, LAT_MIN, LAT_MAX)
    },
    ruleLon: function (value) {
      return this.ruleLocation(value, LON_MIN, LON_MAX)
    },
    onChange: function () {
      this.$nextTick(() => {
        if (this.valid) {
          this.$emit('update:value', [[this.coordinateToNumber(this.valueLocal[0][0]), this.coordinateToNumber(this.valueLocal[0][1])]])
        }
      })
    }
  }
}

